import React from 'react';
import { usePricesMachineContext, useSelectorMachineContext } from '@printdeal/product-selector';
import { Alert } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import CutOffTimeText from '../../detail/advanced/summary/CutOffTimeText';

export const CutOffTime = () => {
  const currentSelection = useSelectorMachineContext((state) => state.context.selection);
  const selectionMode = useSelectorMachineContext((state) => state.context.selectionMode);
  const productAttributes = useSelectorMachineContext((state) => state.context.productAttributes);
  const merchantRules = useSelectorMachineContext((state) => state.context.merchantRules);
  const selectorArrivalDates = useSelectorMachineContext((state) => state.context.arrivalDates);
  const isReviewPage = useSelectorMachineContext((state) => state.context.isReviewPage);
  const selectedArrivalDate = usePricesMachineContext((state) => state.context.selectedArrivalDate);
  const selectedDeliveryOption = useSelectorMachineContext((state) => state.context.selectedDeliveryOption);
  const cutofftime = merchantRules.cutofftime || selectedDeliveryOption.cutofftime;
  const allowFileDelivery = productAttributes?.find(({ key }) => key === 'Artwork Required')?.resolvedValue === 'Yes';
  const isStepByStep = selectionMode === 'step-by-step';

  const arrivalDate = selectedDeliveryOption.date ?? (isStepByStep ? selectedArrivalDate : selectorArrivalDates?.find(
    (date) => date.deliveryType === currentSelection['Delivery Type'],
  )?.date);

  if (!cutofftime || !arrivalDate) return null;

  return (
    <div className="pd-flex pd-flex-col pd-gap-4">
      {isStepByStep && !isReviewPage && (
        <div className="pd-font-bold pd-text-dim-800">
          <FormattedMessage id="account.order.delivery.title" defaultMessage="Delivery" />
        </div>
      )}
      <Alert variant="info" className="pd-font-normal">
        <CutOffTimeText
          cutOffTime={cutofftime}
          allowFileDelivery={allowFileDelivery}
          selectedDeliveryTool="editor"
          deliveryDate={arrivalDate}
        />
      </Alert>
    </div>
  );
};
